<div class="dropdown-row-container" *ngIf="ShowComponent && !loading">

  <!-- <div *ngIf="ShowGroupDropdown">
    <app-filter-object-option-select></app-filter-object-option-select>
  </div> -->
  <div *ngIf="ShowSubGroupDropdown">
    <app-filter-object-option-select [BindId]="'id'" [BindName]="'name'" [Options]="SubgroupArray"
      [PlaceholderFilter]="('ROLE_FILTER.Subgroup' | translate)" [SelectedText]="('ROLE_FILTER.subgroups' | translate)"
      [NoOptionsText]="('ROLE_FILTER.no_options' | translate)" [SelectedOptions]="RoleFilterSelected.SubGroups"
      [IconUrl]="''" [Multiselect]="true" [zIndex]="1001"
      (filterValueEmitter)="onSubGroupChange($event)"></app-filter-object-option-select>

  </div>
  <div *ngIf="ShowCallCentersDropdown">
    <app-filter-object-option-select [BindId]="'id'" [BindName]="'name'" [Options]="CallCenterArray"
      [PlaceholderFilter]="'Call center'" [SelectedText]="'Call center(s)'"
      [NoOptionsText]="('ROLE_FILTER.no_options' | translate)" [SelectedOptions]="RoleFilterSelected.CallCenters"
      [IconUrl]="''" [Multiselect]="true"
      (filterValueEmitter)="onCallCenterChange($event)"></app-filter-object-option-select>
  </div>
  <div *ngIf="ShowCenterDropdown">
    <app-filter-object-option-select [BindId]="'id'" [BindName]="'name'" [Options]="CenterArray"
      [PlaceholderFilter]="('ROLE_FILTER.Center' | translate)" [SelectedText]="('ROLE_FILTER.centers' | translate)"
      [NoOptionsText]="('ROLE_FILTER.no_options' | translate)" [SelectedOptions]="RoleFilterSelected.Centers"
      [IconUrl]="''" [Multiselect]="true" [zIndex]="1001"
      (filterValueEmitter)="onCenterChange($event)"></app-filter-object-option-select>
  </div>
  <div *ngIf="ShowUserDropdown">
    <app-filter-object-option-select [BindId]="'id'" [BindName]="'name'" [Options]="UserArray"
      [PlaceholderFilter]="('ROLE_FILTER.User' | translate)" [SelectedText]="('ROLE_FILTER.users' | translate)"
      [NoOptionsText]="('ROLE_FILTER.no_options' | translate)" [SelectedOptions]="RoleFilterSelected.Users"
      [zIndex]="1001" [IconUrl]="''" [Multiselect]="true"
      (filterValueEmitter)="onUserChange($event)"></app-filter-object-option-select>
  </div>

  <div class="button-white button-padding-6" style="font-size: 14px; align-self: stretch;" (click)="clearFilter()">
    {{('ROLE_FILTER.clear' | translate)}}
  </div>


</div>